module.exports = __webpack_public_path__ + "images/966f8c3860f6011483a0b0ac6c1623cb-shield.png";